import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import {convertConditionAPICardToAICard} from '../../../../tools/general/addOrUpdateCardTool/schemaConverters/conditionCard/convertConditionAPICardToAICard';
import {z} from 'zod';

export default function getCardDetailsTool() {
  async function execute() {
    const card = getCardFromState();

    return toolResult(JSON.stringify(convertConditionAPICardToAICard(card)));
  }

  return tool({
    name: V2CardAgentToolName.GetCardDetails,
    description: 'Retrieves full details of a card by its ID.',
    displayName: 'Getting card details',
    inputSchema: z.object({}),
    execute,
  });
}
